import { PageLayout } from '../components/PageLayout';
import { LeadershipHero } from '../components/sections/LeadershipHero';
import { OutcomeMetricsBar } from '../components/sections/OutcomeMetricsBar';
import { InferenceChallenges } from '../components/sections/InferenceChallenges';
import { FeatureHighlights } from '../components/sections/FeatureHighlights';
import { TerminalDemo } from '../components/sections/TerminalDemo';
import { ROICalculator } from '../components/ROICalculator';

/**
 * Landing Page — The pitch.
 *
 * 1. Hero — The Intelligence Layer for GPU Inference (text + animated diagram)
 * 2. Outcome Metrics Bar — animated counters + trust signals + NVIDIA tagline
 * 3. Three Challenges at Scale — the core GPU inference problems
 * 4. Feature Highlights — featured Architecture card + 5 detail cards
 * 5. Terminal Demo — Helm install in 3 tabs
 * 6. ROI Calculator — Interactive savings calculator
 * 7. Footer (via PageLayout)
 */
export const LandingProprietary = () => {
    return (
        <PageLayout>
            <LeadershipHero />

            <OutcomeMetricsBar />

            <InferenceChallenges />

            <FeatureHighlights />

            <div id="get-started">
                <TerminalDemo />
            </div>

            <div id="calculator">
                <ROICalculator />
            </div>
        </PageLayout>
    );
};
